var _g, _g2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChrome = function SvgChrome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 40,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40)"
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8h24v24H8z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 12H13a2 2 0 00-2 2v12a2 2 0 002 2h4v-2h-4V16h14v10h-4v2h4a2.006 2.006 0 002-2V14a2 2 0 00-2-2zm-7 6l-4 4h3v6h2v-6h3z",
    fill: "#7c7c7c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    opacity: 0,
    width: 40,
    height: 40,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.744 20.27a13.9 13.9 0 00-.19-2.27h-11.3v4.51h6.47a5.571 5.571 0 01-2.4 3.58v3h3.86a11.733 11.733 0 003.56-8.82z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.254 32a11.431 11.431 0 007.93-2.91l-3.86-3a7.239 7.239 0 01-4.07 1.16 7.167 7.167 0 01-6.73-4.96h-3.98v3.09A11.982 11.982 0 0020.254 32z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.524 22.29a6.963 6.963 0 01-.38-2.29 7.234 7.234 0 01.38-2.29v-3.09h-3.98A11.861 11.861 0 008.254 20a11.861 11.861 0 001.29 5.38z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.254 12.75a6.511 6.511 0 014.6 1.8l3.42-3.42A11.473 11.473 0 0020.254 8a11.982 11.982 0 00-10.71 6.62l3.98 3.09a7.167 7.167 0 016.73-4.96z",
    fill: "#ea4335"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChrome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chrome.8b51f721.svg";
export { ForwardRef as ReactComponent };